import { AUTOMATION_SOURCE } from 'utils/constants';

export const EMPTY_PROTOCOL_AUTOMATION = Object.freeze({});

/**
 * Protocol suggestions (`{ [fieldName]: '/' }`) in the shape of the form's automation entries, so the
 * existing chip and the Submit / Ctrl+Enter prefill can use them as they are.
 */
export function toProtocolAutomationEntries(suggestions) {
    const fieldNames = Object.keys(suggestions ?? {});
    if (!fieldNames.length) return EMPTY_PROTOCOL_AUTOMATION;

    return Object.freeze(
        Object.fromEntries(
            fieldNames.map((fieldName) => [fieldName, Object.freeze({ sourceValue: suggestions[fieldName], source: AUTOMATION_SOURCE.PROTOCOL })])
        )
    );
}

/**
 * Adds the protocol entries to the form's automation with the LOWEST priority: any other suggestion for
 * the same field wins. Returns the same `automation` object when there is nothing to add.
 */
export function mergeProtocolAutomation(automation, protocolEntries) {
    const missing = Object.keys(protocolEntries ?? {}).filter((fieldName) => automation?.[fieldName] == null);
    if (!missing.length) return automation;

    const merged = { ...(automation ?? {}) };
    missing.forEach((fieldName) => {
        merged[fieldName] = protocolEntries[fieldName];
    });
    return merged;
}
